/* eslint-disable @typescript-eslint/no-explicit-any */

import { FC, useEffect, useState } from 'react';
import { Button, Container } from '@/components';
import { useQuery } from '@tanstack/react-query';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import { Dialog } from 'primereact/dialog';

import { useTranslation } from 'react-i18next';
import { getSOLAS } from './getSOLASList';
import SOLASTable from './SOLASTable/SOLASTable';
import styles from './SOLAS.module.scss';
import { SolasInfo } from './types';

const PopUpHeader: FC = () => {
  const { t } = useTranslation('solas');

  return (
    <div className={styles.popUpHeaderContainer}>
      <FontAwesomeIcon icon={faWarning} className={styles.icon} />
      <h2>{t('titleImportant')}</h2>
    </div>
  );
};

export type ParsedSolasInfo = Omit<
  SolasInfo,
  'tipoContenedor' & 'cierreStacking'
> & {
  tipo?: string;
  tamano?: string;
  cierreStacking?: Date;
};

const Solas: FC = () => {
  const { t } = useTranslation('solas');
  const [visible, setVisible] = useState<boolean>(false);
  const [parsedData, setParsedData] = useState<ParsedSolasInfo[]>([]);

  const { data, isLoading } = useQuery<SolasInfo[]>({
    queryKey: ['solas'],
    queryFn: getSOLAS,
  });
  const openPopUp = () => {
    setVisible(true);
  };
  useEffect(() => {
    if (data) {
      const newData = data.map((item: any) => {
        const { tipoContenedor, ...rest } = item;
        const [tipo, tamano] = (tipoContenedor ?? '').split(' ');
        const formattedCierreStacking = new Date(item?.cierreStacking);

        return {
          ...rest,
          tipo,
          tamano,
          cierreStacking: formattedCierreStacking,
        };
      });
      setParsedData(newData);
    }
  }, [data]);

  return (
    <Container className={styles.solas}>
      <header>
        <h2 className={styles.title}>{t('solas')}</h2>
        <Button
          label=""
          className={styles.importantInfoButton}
          onClick={openPopUp}
        >
          <FontAwesomeIcon icon={faWarning} className={styles.icon} />
          {t('titleImportant')}
        </Button>
      </header>
      <Dialog
        header={<PopUpHeader />}
        visible={visible}
        style={{ maxWidth: '480px' }}
        onHide={() => setVisible(false)}
        contentClassName={styles.popUp}
        breakpoints={{ '1100px': '75vw', '960px': '95vw' }}
      >
        <p>{t('importantInformation')}</p>
        <p>{t('customerStatementTitle')} </p>
        <p>{t('customerStatement')} </p>
      </Dialog>
      <SOLASTable data={parsedData} isLoading={isLoading} />
    </Container>
  );
};

export default Solas;
